
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LayoutItemProps } from ".";
import { loading, endLoading } from "store/layout";

interface ApiLayoutRemoveInputProps {
    ids: number[]
}

type ApiLayoutRemoveOutputProps = OutputBaseProps<{ item: LayoutItemProps; }>

export const apiLayoutRemove = async (data: ApiLayoutRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiLayoutRemoveOutputProps>("/api/layout/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};